import { Multiselect } from '@cokitchen/cokitchen-components';
import useWeeklyRosterContext from 'contexts/weekly-roster.context';
import React from 'react';
import { getUserName } from 'utils/functions';

const ScreenDetails = ({
  staffs,
  handleChange
}: {
  staffs: string[];
  handleChange?: (e: string[]) => void;
}) => {
  const { staff } = useWeeklyRosterContext();
  const staffOptions = staff.map((s) => ({
    text: getUserName(s),
    value: s.staff_number
  }));

  return (
    <div className='pb-8'>
      <div>
        <Multiselect
          placeholder='Select staff'
          values={staffs}
          options={staffOptions}
          onChange={(e) => handleChange?.(e)}
          hasSearch
          filterResults
        />
      </div>
    </div>
  );
};

export default ScreenDetails;
